import { supabase } from "../supabaseclient";

export const createUserRecord = async (user) => {
  try {
    // Check if user already exists
    const { data: existingUser, error: checkError } = await supabase
      .from("users")
      .select("id")
      .eq("id", user.id)
      .single();

    if (checkError && checkError.code === "PGRST116") {
      // User doesn't exist, create them
      const { error: insertError } = await supabase.from("users").insert({
        id: user.id,
        email: user.email,
        profile_created: false,
      });

      if (insertError) {
        console.error("Error creating user record:", insertError);
        // Don't fail the auth process - just log the error
        return false;
      } else {
        return true;
      }
    } else if (existingUser) {
      return true;
    }

    return true; // Default return
  } catch (error) {
    console.error("Error in createUserRecord:", error);
    // Don't fail the auth process - just log the error
    return false;
  }
};

export const setupAuthListener = () => {
  return supabase.auth.onAuthStateChange(async (event, session) => {
    if (event === "SIGNED_IN" && session?.user) {
      try {
        // Add a timeout to prevent hanging
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(
            () => reject(new Error("User record creation timeout")),
            5000
          );
        });

        await Promise.race([createUserRecord(session.user), timeoutPromise]);
      } catch (error) {
        console.error("Error in auth listener:", error);
        // Don't let this break the auth flow
      }
    }
  });
};
